<svelte:options
  customElement={{
    tag: "oc-divider-v1",
    /*                       */
    extend: window.__components.extend(),
    props: {
      alignment: { type: "String" },
      variant: { type: "String" },
      orientation: { type: "String", reflect: true },
    },
  }}
/>

<script lang="ts">
  import type { Props } from "./DividerV1.types.js";
  import DefaultStyles from "../../../common/components/DefaultStyles/DefaultStyles.svelte";

  let { alignment = "center", orientation = "horizontal", variant = "solid" }: Props = $props();
</script>

<div
  class={`divider divider-alignment--${alignment}`}
  class:divider--vertical={orientation === "vertical"}
  style:--border-style={variant}
></div>

<DefaultStyles />

<style lang="scss" global>
  @use "@otto-ec/design-tokens/component" as tokens;
  @use "@otto-ec/otto-components-utils/scss/mixins";

  :host {
    --border-style: unset;
    position: relative;
    display: block;
    width: inherit;
  }

  :host([orientation="vertical"]) {
    height: inherit;
  }

  .divider {
    position: absolute;
    display: block;
    left: 0;
    width: 100%;
    border-top: 1px var(--border-style) tokens.$oc-component-divider-border-color;
    transform: translateY(-0.5px);

    &-alignment {
      &--top {
        transform: translateY(-1px);
      }

      &--bottom {
        transform: unset;
      }
    }

    &--vertical {
      left: unset;
      top: 0;
      width: 0;
      height: 100%;
      border-left: 1px var(--border-style) tokens.$oc-component-divider-border-color;
      transform: translateX(-0.5px);
    }

    &--vertical.divider-alignment {
      &--left {
        transform: translateX(-1px);
      }

      &--right {
        transform: unset;
      }
    }
  }
</style>
